export const initialState = {
    loading: false,
    subModelsList: [],
};
